// extracted by mini-css-extract-plugin
export default {"error":"ErrorDisplay_error__vGfFI"};